import React, { useMemo } from "react";
import { UserLoggedInNavigatorScreenProps } from "../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import {
  OrgSpaceWidgetAddDrawer,
  OrgSpaceWidgetAddRouteKey,
} from "./OrgSpaceWidgetAddDrawer";
import { OrgSpaceWACategoryNote } from "./OrgSpaceWACategoryNote";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import { OrgSpaceWidgetAddCategories } from "./OrgSpaceWidgetAddCategories";
import { DrawerContentComponentProps } from "@react-navigation/drawer";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";
import { OrgSpaceWACategoryFile } from "./OrgSpaceWACategoryFile";
import { WADrawerScreenOptions } from "../../Storecast/Storecast/WidgetAdd/WARegular";
import { WebModalHeader } from "../WorkspaceTodos/WorkspaceTodoEdit/WorkspaceTodoEditMain/WebModalHeader";

export const OrgSpaceWidgetAdd = withWebModal(
  (props: UserLoggedInNavigatorScreenProps<"OrgSpaceWidgetAdd">) => {
    const intl_tokens = useIntlTokens();
    return (
      <>
        <WebModalHeader
          title={
            <WebModalHeader.Title>{intl_tokens.AddWidget}</WebModalHeader.Title>
          }
          close={
            <WebModalHeader.CloseButton
              onPress={() => {
                props.navigation.goBack();
              }}
            />
          }
        />
        <OrgSpaceWidgetAddDrawer.Navigator
          defaultStatus="open"
          drawerContent={(drawerProps) => (
            <OrgSpaceWidgetAddDrawerContent
              {...drawerProps}
              onPress={(key) => {
                drawerProps.navigation.navigateDeprecated(key, {
                  spaceId: props.route.params.spaceId,
                  position: props.route.params.position,
                  maxSize: props.route.params.maxSize,
                });
              }}
            />
          )}
          screenOptions={WADrawerScreenOptions}
        >
          <OrgSpaceWidgetAddDrawer.Screen
            name="OrgSpaceWACategoryNote"
            component={OrgSpaceWACategoryNote}
            initialParams={{
              spaceId: props.route.params.spaceId,
              position: props.route.params.position,
              maxSize: props.route.params.maxSize,
              workspaceId: props.route.params.workspaceId,
            }}
          />
          <OrgSpaceWidgetAddDrawer.Screen
            name="OrgSpaceWACategoryFile"
            component={OrgSpaceWACategoryFile}
            initialParams={{
              spaceId: props.route.params.spaceId,
              position: props.route.params.position,
              maxSize: props.route.params.maxSize,
              workspaceId: props.route.params.workspaceId,
            }}
          />
        </OrgSpaceWidgetAddDrawer.Navigator>
      </>
    );
  }
);

function OrgSpaceWidgetAddDrawerContent(
  props: DrawerContentComponentProps & {
    onPress: (key: OrgSpaceWidgetAddRouteKey) => void;
  }
) {
  const selectedRouteName = useMemo(() => {
    return props.state.routeNames[
      props.state.index
    ] as OrgSpaceWidgetAddRouteKey;
  }, [props.state.index, props.state.routeNames]);

  return (
    <OrgSpaceWidgetAddCategories
      onPress={props.onPress}
      selected={selectedRouteName}
    />
  );
}
